var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.402,
    height: 11,
    viewBox: "0 0 12.402 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Folder_Move",
    "data-name": "Folder Move",
    d: "M3.322,4.289a.55.55,0,0,1,.384-.155H6.2l.951,1.392a.585.585,0,0,0,.484.252H12.7a.55.55,0,0,1,.384.155.523.523,0,0,1,.159.374v6.029a.523.523,0,0,1-.159.374.55.55,0,0,1-.384.155H3.705a.549.549,0,0,1-.384-.155.523.523,0,0,1-.159-.374V4.663A.523.523,0,0,1,3.322,4.289ZM3.705,3A1.727,1.727,0,0,0,2.5,3.487,1.643,1.643,0,0,0,2,4.663v7.674a1.643,1.643,0,0,0,.5,1.176A1.727,1.727,0,0,0,3.705,14H12.7a1.727,1.727,0,0,0,1.206-.487,1.642,1.642,0,0,0,.5-1.176V6.308a1.643,1.643,0,0,0-.5-1.176A1.727,1.727,0,0,0,12.7,4.644H7.95L7,3.252A.585.585,0,0,0,6.515,3ZM9.191,7.7a.592.592,0,0,0-.822.005.557.557,0,0,0,.005.8l.543.522H6.069a.567.567,0,1,0,0,1.134H8.941l-.573.566a.557.557,0,0,0,.005.8.592.592,0,0,0,.822,0l1.55-1.531a.557.557,0,0,0-.005-.8Z",
    transform: "translate(-2 -3)",
    fill: "#888",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.1dec1749da67ef3fdeca1d1be8e8fa9e.svg";
export { ForwardRef as ReactComponent };